package uz.ferro.erp.ui.footer

import mui.material.Box
import mui.material.Link
import mui.system.sx
import react.FC
import react.useContext
import uz.ferro.erp.AppContext
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.icon.SvgIconView
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.StackLayout
import uz.ferro.erp.ui.VerticalLayout
import web.cssom.AlignItems
import web.cssom.Auto
import web.cssom.Color
import web.cssom.Position
import web.cssom.integer
import web.cssom.number
import web.cssom.pct
import web.cssom.px
import web.cssom.url

val Footer = FC {

    val navigator = useContext(NavigationContext)
    val appContext = useContext(AppContext)
    val isDesktop = appContext.isMd
    val isMobile = isDesktop.not()

    Box {
        sx {
            width = 100.pct
            minHeight = 120.px
            backgroundColor = Colors.footerBackground
        }

        Box {
            sx {
                paddingTop = 24.px
                paddingBottom = 24.px
            }

            StackLayout {
                isHorizontal = isDesktop

                if (isMobile) {
                    space = 24.px
                }

                sx {
                    marginLeft = Auto.auto
                    marginRight = Auto.auto
                    maxWidth = MAX_PAGE_AREA
                    paddingLeft = 16.px
                    paddingRight = 16.px

                    if (isMobile) {
                        alignItems = AlignItems.center
                    }
                }

                VerticalLayout {
                    space = 16.px
                    sx {
                        alignItems = AlignItems.center
                    }
                    AppTextMedium {
                        text = "Ijtimoiy tarmoqlarda"
                        sx {
                            fontSize = 18.px
                        }
                        color = Colors.white
                    }

                    HorizontalLayout {
                        space = 16.px

                        SvgIconView {
                            size = 32
                            url = "/icons/telegram_footer.svg"
                            onClick = {

                            }
                        }

                        SvgIconView {
                            size = 32
                            url = "/icons/instagram_footer.svg"
                            onClick = {
                            }
                        }

                        SvgIconView {
                            size = 32
                            url = "/icons/facebook_footer.svg"
                            onClick = {}
                        }
                    }
                }

                if (isDesktop) {
                    Box {
                        sx {
                            flexGrow = number(1.0)
                        }
                    }
                }

                VerticalLayout {
                    space = 16.px

                    Link {
                        AppTextMedium {
                            color = Colors.white
                            text = "Xizmat ko‘rsatish shartlari"
                        }
                        href = "/#/pages/terms-of-use"
                    }

                    Link {
                        AppTextMedium {
                            color = Colors.white
                            text = "Maxfiylik siyosati"
                        }
                        href = "/#/pages/privacy-policy"
                    }
                }

                if (isDesktop) {
                    Box {
                        sx {
                            flexGrow = number(1.0)
                        }
                    }
                }

                VerticalLayout {
                    space = 16.px

                    HorizontalLayout {
                        space = 16.px

                        sx {
                            alignItems = AlignItems.center
                        }

                        SvgIconView {
                            size = 32
                            url = "/icons/call_footer.svg"
                        }

                        AppTextMedium {
                            color = Colors.white
                            text = "+998 95 xx 20 30"
                        }
                    }

                    HorizontalLayout {
                        space = 16.px
                        sx {
                            alignItems = AlignItems.center
                        }

                        SvgIconView {
                            size = 32
                            url = "/icons/email_footer.svg"
                        }

                        AppTextMedium {
                            color = Colors.white
                            text = "contact@ferro.uz"
                        }
                    }
                }
            }
        }
    }
}